import React from "react";

export default function TemplatePreview({ template }) {
  if (!template) return null;

  return (
    <div style={{
      width: 400,
      borderRight: "1px solid #eee",
      padding: 10,
      overflowY: "auto",
      background: "#f9f9f9"
    }}>
      <div style={{ fontSize: 12 }}>
        <div style={{ marginBottom: 4, paddingBottom: 4, borderBottom: "1px solid #ddd" }}>
          <strong>{template.name}</strong>
        </div>
        {template.formatted_criteria && template.formatted_criteria.length > 0 ? (
          template.formatted_criteria.map((criterion, idx) => {
            const combinedText = `${criterion.label}: ${criterion.value}`;
            const shouldInline = combinedText.length < 40;

            return shouldInline ? (
              <div key={idx} style={{ marginBottom: 0, display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                <span style={{ fontWeight: 600, color: "#555", marginRight: 8 }}>
                  {criterion.label}:
                </span>
                <span style={{ color: "#333", textAlign: "right", flex: "0 0 auto" }}>
                  {criterion.value}
                </span>
              </div>
            ) : (
              <div key={idx} style={{ marginBottom: 0 }}>
                <div style={{ fontWeight: 600, color: "#555", marginBottom: 2 }}>
                  {criterion.label}
                </div>
                <div style={{ color: "#333", paddingLeft: 8 }}>
                  {criterion.value}
                </div>
              </div>
            );
          })
        ) : (
          <div style={{ color: "#999", fontStyle: "italic" }}>
            {I18n && I18n.t ? I18n.t("templates.no_criteria") : "No criteria to display"}
          </div>
        )}
      </div>
    </div>
  );
}
